export const whiteSwooshDarkTheme = `/* just a .dark-mode class selector wasn't specific enough to override styles so some containers are targeted by id */
  #ciclp-app, #footer-wrapper, #commerce-header-v2-wrapper, #experience-wrapper, .modalRootShopTheImage, .dark-mode {
    --podium-cds-icon-button-color-bg-primary: var(--podium-cds-color-white);
    --podium-cds-icon-button-color-bg-primary-on-light: var(--podium-cds-color-black);
    --podium-cds-icon-button-color-bg-primary-on-dark: var(--podium-cds-color-white);
    --podium-cds-icon-button-color-bg-primary-hover: var(--podium-cds-color-grey-400);
    --podium-cds-icon-button-color-bg-primary-hover-on-light: var(--podium-cds-color-grey-400);
    --podium-cds-icon-button-color-bg-primary-hover-on-dark: var(--podium-cds-color-grey-700);
    --podium-cds-icon-button-color-bg-disabled: var(--podium-cds-color-grey-500);
    --podium-cds-icon-button-color-bg-disabled-on-light: var(--podium-cds-color-grey-200);
    --podium-cds-icon-button-color-bg-disabled-on-dark: var(--podium-cds-color-grey-500);
    --podium-cds-icon-button-color-bg-secondary: var(--podium-cds-color-black);
    --podium-cds-icon-button-color-bg-secondary-on-light: var(--podium-cds-color-grey-100);
    --podium-cds-icon-button-color-bg-secondary-on-dark: var(--podium-cds-color-black);
    --podium-cds-icon-button-color-bg-secondary-hover: var(--podium-cds-color-grey-700);
    --podium-cds-icon-button-color-bg-secondary-hover-on-light: var(--podium-cds-color-grey-300);
    --podium-cds-icon-button-color-bg-secondary-hover-on-dark: var(--podium-cds-color-grey-700);
    --podium-cds-icon-button-color-bg-tertiary-hover: var(--podium-cds-color-grey-700);
    --podium-cds-icon-button-color-bg-tertiary-hover-on-light: var(--podium-cds-color-grey-200);
    --podium-cds-icon-button-color-bg-tertiary-hover-on-dark: var(--podium-cds-color-grey-700);
    --podium-cds-button-color-bg-primary-disabled-on-dark: var(--podium-cds-color-grey-500);
    --podium-cds-button-color-bg-primary-disabled-on-light: var(--podium-cds-color-grey-200);
    --podium-cds-button-color-bg-primary-disabled: var(--podium-cds-color-grey-500);
    --podium-cds-button-color-bg-primary-hover-on-dark: var(--podium-cds-color-grey-300);
    --podium-cds-button-color-bg-primary-hover-on-light: var(--podium-cds-color-grey-500);
    --podium-cds-button-color-bg-primary-hover: var(--podium-cds-color-grey-300);
    --podium-cds-button-color-bg-primary-on-dark: var(--podium-cds-color-black);
    --podium-cds-button-color-bg-primary-on-light: var(--podium-cds-color-white);
    --podium-cds-button-color-bg-primary: var(--podium-cds-color-white);
    --podium-cds-button-color-border-secondary-disabled-on-dark: var(--podium-cds-color-grey-600);
    --podium-cds-button-color-border-secondary-disabled: var(--podium-cds-color-grey-300);
    --podium-cds-button-color-border-secondary-hover-on-dark: var(--podium-cds-color-white);
    --podium-cds-button-color-border-secondary-hover: var(--podium-cds-color-white);
    --podium-cds-button-color-border-secondary-on-dark: var(--podium-cds-color-grey-400);
    --podium-cds-button-color-border-secondary-on-light: var(--podium-cds-color-grey-300);
    --podium-cds-button-color-border-secondary: var(--podium-cds-color-grey-400);
    --podium-cds-color-warning-inverse: var(--podium-cds-color-yellow-200);
    --podium-cds-color-warning: var(--podium-cds-color-yellow-100);
    --podium-cds-color-info-inverse: var(--podium-cds-color-blue-500);
    --podium-cds-color-info: var(--podium-cds-color-blue-400);
    --podium-cds-color-success-inverse: var(--podium-cds-color-green-600);
    --podium-cds-color-success: var(--podium-cds-color-green-500);
    --podium-cds-color-critical-inverse: var(--podium-cds-color-red-600);
    --podium-cds-color-critical: var(--podium-cds-color-red-400);
    --podium-cds-color-border-disabled-on-dark: var(--podium-cds-color-grey-700);
    --podium-cds-color-border-disabled-on-light: var(--podium-cds-color-grey-300);
    --podium-cds-color-border-disabled: var(--podium-cds-color-grey-700);
    --podium-cds-color-border-active-on-dark: var(--podium-cds-color-white);
    --podium-cds-color-border-active-on-light: var(--podium-cds-color-black);
    --podium-cds-color-border-active-inverse: var(--podium-cds-color-black);
    --podium-cds-color-border-active: var(--podium-cds-color-white);
    --podium-cds-color-border-primary-inverse: var(--podium-cds-color-grey-500);
    --podium-cds-color-border-primary-on-light: var(--podium-cds-color-grey-500);
    --podium-cds-color-border-primary-on-dark: var(--podium-cds-color-grey-400);
    --podium-cds-color-border-primary: var(--podium-cds-color-grey-400);
    --podium-cds-color-border-secondary: var(--podium-cds-color-grey-600);
    --podium-cds-color-border-tertiary: var(--podium-cds-color-grey-700);
    --podium-cds-color-border-success: var(--podium-cds-color-green-500);
    --podium-cds-color-border-critical: var(--podium-cds-color-red-400);
    --podium-cds-color-text-disabled-on-dark: var(--podium-cds-color-grey-600);
    --podium-cds-color-text-disabled-on-light: var(--podium-cds-color-grey-400);
    --podium-cds-color-text-disabled-inverse: var(--podium-cds-color-grey-400);
    --podium-cds-color-text-disabled: var(--podium-cds-color-grey-600);
    --podium-cds-color-text-hover-on-dark: var(--podium-cds-color-grey-200);
    --podium-cds-color-text-hover-on-light: var(--podium-cds-color-grey-500);
    --podium-cds-color-text-hover-inverse: var(--podium-cds-color-grey-600);
    --podium-cds-color-text-hover: var(--podium-cds-color-grey-200);
    --podium-cds-color-text-secondary-on-dark: var(--podium-cds-color-grey-400);
    --podium-cds-color-text-secondary-on-light: var(--podium-cds-color-grey-500);
    --podium-cds-color-text-secondary-inverse: var(--podium-cds-color-grey-500);
    --podium-cds-color-text-secondary: var(--podium-cds-color-grey-400);
    --podium-cds-color-text-primary-on-dark: var(--podium-cds-color-black);
    --podium-cds-color-text-primary-on-light: var(--podium-cds-color-black);
    --podium-cds-color-text-primary-inverse: var(--podium-cds-color-black);
    --podium-cds-color-text-primary: var(--podium-cds-color-white);
    --podium-cds-color-text-critical: var(--podium-cds-color-red-400);
    --podium-cds-color-text-success: var(--podium-cds-color-green-500);
    --podium-cds-color-text-link: var(--podium-cds-color-blue-400);
    --podium-cds-color-text-badge: var(--podium-cds-color-orange-300);
    --podium-cds-color-bg-primary-on-light: var(--podium-cds-color-black);
    --podium-cds-color-bg-primary-on-dark: var(--podium-cds-color-white);
    --podium-cds-color-bg-primary-inverse: var(--podium-cds-color-black);
    --podium-cds-color-bg-primary: var(--podium-cds-color-grey-900);
    --podium-cds-color-bg-secondary: var(--podium-cds-color-black);
    --podium-cds-color-bg-hover-inverse: var(--podium-cds-color-grey-200);
    --podium-cds-color-bg-hover: var(--podium-cds-color-grey-700);
    --podium-cds-color-bg-disabled-inverse: var(--podium-cds-color-grey-200);
    --podium-cds-color-bg-disabled: var(--podium-cds-color-grey-600);
    --podium-cds-color-bg-modal: var(--podium-cds-color-grey-800);
    --podium-cds-color-bg-warning: var(--podium-cds-color-yellow-100);
    --podium-cds-color-bg-critical: var(--podium-cds-color-red-400);
    --podium-cds-color-bg-success: var(--podium-cds-color-green-500);
    --podium-cds-color-bg-on-image-secondary: var(--podium-cds-color-grey-500);
    --podium-cds-color-bg-on-image-primary: var(--podium-cds-color-grey-200);
    --podium-cds-color-bg-active: var(--podium-cds-color-grey-700);
    color: var(--podium-cds-color-text-primary);
    background-color: var(--podium-cds-color-bg-primary);
}
/* override base styles to set a black background when scrolling beyond the edges, and ensure white fonts*/
body {
  background-color: var(--podium-cds-color-black);
  color: var(--podium-cds-color-white);
}
/* ncss is setting them to text --podium-cds-color-black, override anchor tags to text-primary so theming works */
a {
  color: var(--podium-cds-color-text-primary);
}

/* just a .dark-mode class selector wasn't specific enough to override styles so some containers are targeted by id */
#ciclp-app {
    --podium-cds-button-color-bg-primary-on-dark: var(--podium-cds-color-white);
    --podium-cds-button-color-bg-primary: var(--podium-cds-color-white);
    --podium-cds-color-text-primary-inverse: var(--podium-cds-color-white);
    --podium-cds-color-text-primary: var(--podium-cds-color-white);
    color: var(--podium-cds-color-text-primary);
    background-color: var(--podium-cds-color-bg-primary);
    /* volt color should not be applied to merch menu */
    [data-container-type="merch_menu"] {
      --podium-cds-color-text-primary-inverse: var(--podium-cds-color-black);
      --podium-cds-color-text-primary: var(--podium-cds-color-white);
      color: var(--podium-cds-color-text-primary);
    }
    --podium-cds-button-color-bg-primary-hover: var(--podium-cds-color-grey-300);
  
  /* CICLP cart error dialog overrides */
    #nike-shop-root .modal-container{
    background-color: var(--podium-cds-color-bg-primary);
    [data-automation="error-message-container"]{
      background-color: var(--podium-cds-color-bg-primary);
      --podium-cds-color-text-primary-on-light:var(--podium-cds-color-white);
    }
  }

  /* Override NCSS cta-primary-light class on anchor-based CTAs (e.g. carousel "View All") */
  .nav-btn-wrapper {
    a.cta-primary-light,
    a.cta-primary-dark {
      color: var(--podium-cds-color-text-primary);
    }
  } 
}
 .modal-portal-content-wrapper{
    --podium-cds-color-bg-primary: var(--podium-cds-color-grey-900);
    --podium-cds-button-color-bg-primary: var(--podium-cds-color-white);
    --podium-cds-color-text-primary: var(--podium-cds-color-white);
    --podium-cds-color-text-primary-on-light: var(--podium-cds-color-white);
    --podium-cds-color-text-primary-on-dark: var(--podium-cds-color-grey-900);
    --podium-cds-color-text-primary-inverse: var(--podium-cds-color-grey-900);
    --podium-cds-color-text-secondary:var(--podium-cds-color-grey-400);
    --podium-cds-icon-button-color-bg-secondary: var(--podium-cds-color-black);
    --podium-cds-color-border-disabled: var(--podium-cds-color-grey-700);

    .language-button {
      color: var(--podium-cds-color-grey-900);
    }
    .mismatch-country-button {
      color:var(--podium-cds-color-grey-900);
    } 
    
    /* Override cookies modal in dark mode */  
    .cookie-modal-base {
    /* Make critical text accessible in cookie modal  */
      --podium-cds-color-text-critical: #FF3336;
      .modal-backdrop-container::before {
        background: var(--podium-cds-color-bg-primary);
      }
      .modal-backdrop-container::after {
        background: var(--podium-cds-color-bg-primary);
      }
    }
  }
}
/* make the swoosh red */
a.swoosh-link {
    color: var(--podium-cds-color-text-primary);
}
    
}`;
